import { streamMinimized } from 'features/layout/actions';
import { selectMaximizedStream } from 'features/layout/features/content/contentSlice';
import { selectRecordingHiddenUserIds } from 'features/layout/features/config/systemSessionSelectors';
import { SourceDetails } from 'features/layout/types';
import { UserId } from 'features/users/types';
import { changeRole } from 'features/users/usersSlice';
import { put, select } from 'redux-saga/effects';

export function* minimizeHiddenRoleStageSaga({ payload }: ReturnType<typeof changeRole>) {
  const maximizedStream: SourceDetails | null = yield select(selectMaximizedStream);

  if (maximizedStream?.kind !== 'remote' || maximizedStream.userId !== payload.id) {
    return;
  }

  const hiddenUserIds: UserId[] = yield select(selectRecordingHiddenUserIds);

  if (hiddenUserIds.includes(payload.id)) {
    yield put(streamMinimized());
  }
}
